import { configureStore } from '@reduxjs/toolkit';
import calendarReducer from './slices/calendarSlice';
import dashboardReducer from './slices/dashboardSlice';
import rolesAndPermissionsReducer from './slices/rolesAndPermissionsSlice';
import integrationReducer from './slices/integrationSlice';
import authReducer from './slices/authSlice';
import leadsReducer from './slices/leadsSlice';

export const store = configureStore({
  reducer: {
    calendar: calendarReducer,
    dashboard: dashboardReducer,
    rolesAndPermissions: rolesAndPermissionsReducer,
    integration: integrationReducer,
    auth: authReducer,
    leads: leadsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
